import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Contact } from 'src/models/DTO/contact/contact';
import { ContactsV2 } from 'src/models/DTO/contact/contactsV2';
import { FullContactV2 } from 'src/models/DTO/contact/fullContactV2';
import { PlainContactV2 } from 'src/models/DTO/contact/plainContactV2';
import { Config } from '../../../infrastructure/config';
import { ContactRequestModel } from '../../../models/requestModels/contact/contactRequestModel';
import { PhoneRequestModel } from 'src/models/requestModels/contact/PhoneRequestModel';

@Injectable({
  providedIn: 'root'
})
export class ContactService {


  private contactRegistrationURL : string = Config.api + "contact";
  private contactGetterURL : string = Config.api + "user/contacts?include=country";


  constructor(private httpClient: HttpClient) { }

  registerUserContact(contactRequestModel: ContactRequestModel) {
    return this.httpClient.post(this.contactRegistrationURL, contactRequestModel);
  }

  updatePartnerContact(contactRequestModel: ContactRequestModel, currentContactUIID: string) {
    const params = '/' + currentContactUIID;
    return this.httpClient.put(this.contactRegistrationURL + params, contactRequestModel);
  }

  getContactInfoForEntity(contactUIID: string) {
    const params = '/' + contactUIID + '?include=country&fields%5Bcontacts%5D=id%2Cuuid%2Ccountry_id%2Ctype%2Ccity%2Caddress_line_1%2Cpost_code%2Cmobile_phone_1_e164&fields%5Bcountry%5D=id%2Cuuid%2Cname';
    return this.httpClient.get<PlainContactV2>(this.contactRegistrationURL + params);
  }

  getFullContactInfoForEntity(contactUIID: string) {
    const params = '/' + contactUIID
    return this.httpClient.get<FullContactV2>(this.contactRegistrationURL + params);
  }

  getContactsForEntity() {
    return this.httpClient.get<ContactsV2>(this.contactGetterURL);

  }

  updatePhone(contactUUID: string, phoneRequestModel: PhoneRequestModel) { 
    const params = '/' + contactUUID + '/phone'
    return this.httpClient.put(this.contactRegistrationURL + params, phoneRequestModel);
  }

  deleteContact(contactUUID: string) { 
    const params = '/' + contactUUID;
    return this.httpClient.delete(this.contactRegistrationURL + params);
  }
}
